import { render, staticRenderFns } from "./ForcedDeleteFolderDialog.vue?vue&type=template&id=0197c0d2&scoped=true"
import script from "./ForcedDeleteFolderDialog.vue?vue&type=script&lang=js"
export * from "./ForcedDeleteFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197c0d2",
  null
  
)

export default component.exports